<template>
  <v-dialog persistent v-model="open" max-width="480px" @keydown.enter="submit">
    <v-card>
      <v-card-title class="title pt-4 pb-1"> Set new password </v-card-title>

      <p>Please enter new password so that you can log in later on.</p>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="text-xs-left">Your email</div>
          <v-text-field
            name="email"
            type="email"
            :value="currentUser.email"
            class="default-input"
            disabled
            solo
          />

          <div class="text-xs-left">New password</div>
          <v-text-field
            name="password"
            label="Enter your password here."
            id="password"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            @click:append="showPassword = !showPassword"
            v-model="newPassword"
            :rules="passwordRules"
            class="default-input"
            required
            solo
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="!valid"
          @click="submit"
          class="text-capitalize"
          :loading="submiting"
        >
          Set password
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '@/api';
import { firebase } from '@firebase/app';
import '@firebase/auth';

export default {
  name: 'SetPassword',
  data() {
    return {
      showPassword: false,
      open: true,
      valid: false,
      newPassword: '',
      submiting: false,
      passwordRules: [
        v => !!v || 'Password is required',
        v => v.length >= 6 || 'Password must be greater than 6 characters',
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
  },
  methods: {
    async submit(e) {
      e.preventDefault();

      this.submiting = true;
      try {
        await API.user.forceSetPassword({
          newPassword: this.newPassword,
        });

        await firebase
          .auth()
          .signInWithEmailAndPassword(this.currentUser.email, this.newPassword);

        const currentUser = await this.$store.dispatch('getCurrentUser');
        const redirectPath = this.$route.query.redirect;

        if (currentUser.is_advisor) {
          if (redirectPath) {
            this.$router.push(redirectPath);
          } else {
            this.$router.push('/overview');
          }
        } else {
          if (redirectPath) {
            this.$router.push(redirectPath);
          } else {
            this.$router.push('/select-entity');
          }
        }
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message: e.response
            ? e.response.data.error
            : 'Something went wrong. Our engineering team has been notified about this error.',
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      } finally {
        this.submiting = false;
      }
    },
  },
};
</script>

<style scoped lang="postcss">
.v-toolbar {
  background-color: #46535c;
}
.content-container {
  max-width: 400px;
}
.method-title {
}
.logo {
  height: 40px;
  width: auto;
}
.title {
  justify-content: center;
  text-align: center;
  font-weight: bold;
}
</style>
